import React, { useEffect, useState } from "react";
import { X } from "lucide-react";

const SystemRemarkModal = ({ show, onClose, systemRemarkData }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(show);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
      setShouldRender(true);

      setTimeout(() => setIsVisible(true), 10);
    } else {
      document.body.style.overflow = "auto";
      setIsVisible(false);

      setTimeout(() => setShouldRender(false), 400);
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);

  // ESC key close (bonus)
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };

    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  if (!shouldRender) return null;

  return (
    <div
      className="fixed inset-0 z-50"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      {/*  OVERLAY*/}
      <div
        className={`fixed inset-0 transition-opacity duration-300 ${
          isVisible ? "bg-black/40 opacity-100" : "bg-black/0 opacity-0"
        }`}
        onClick={onClose}
      />

      {/*  RIGHT SIDE DRAWER */}
      <div className="fixed inset-0 flex justify-end">
        <div
          onClick={(e) => e.stopPropagation()}
          className={`bg-white h-full w-full md:w-[50%] shadow-xl transform transition-transform duration-300 ease-in-out ${
            isVisible ? "translate-x-0" : "translate-x-full"
          }`}
        >
          {/* HEADER */}
          <div className="flex justify-between items-center px-6 py-4 border-b">
            <h3 className="text-lg font-semibold text-blue-600">
              System Remark
            </h3>

            <button onClick={onClose}>
              <X size={20} />
            </button>
          </div>

          {/* BODY */}
          <div className="p-6 space-y-5 overflow-y-auto h-full">
            {/* NO DATA */}
            {(!systemRemarkData ||
              (systemRemarkData.candidateInfos?.length === 0 &&
                systemRemarkData.consultantInfo?.length === 0)) && (
              <p className="text-gray-500 text-sm italic">
                No system data available.
              </p>
            )}

            {/* Candidate Info */}
            {systemRemarkData?.candidateInfos?.length > 0 && (
              <div>
                <h4 className="font-semibold text-blue-600 mb-2">
                  Candidate Info
                </h4>

                <ul className="list-disc pl-6 text-sm space-y-1">
                  {systemRemarkData.candidateInfos.map((info, idx) => (
                    <li key={idx}>{info}</li>
                  ))}
                </ul>
              </div>
            )}

            {/* Consultant Info */}
            {systemRemarkData?.consultantInfo?.length > 0 && (
              <div>
                <h4 className="font-semibold text-blue-600 mb-3">
                  Consultant Info
                </h4>

                <div className="overflow-x-auto">
                  <table className="w-full text-sm text-center border border-gray-300">
                    <thead className="bg-blue-100">
                      <tr>
                        <th className="p-2 border">Status</th>
                        <th className="p-2 border">Total Candidates</th>
                        <th className="p-2 border">%</th>
                      </tr>
                    </thead>

                    <tbody>
                      {systemRemarkData.consultantInfo.map((row, idx) => {
                        let badgeClass =
                          row.percentage < 20
                            ? "bg-red-500"
                            : row.percentage < 50
                              ? "bg-yellow-400 text-black"
                              : row.percentage < 80
                                ? "bg-blue-400"
                                : "bg-green-500";

                        return (
                          <tr key={idx} className="border-t">
                            <td className="p-2 border">{row.status}</td>
                            <td className="p-2 border">{row.total}</td>
                            <td className="p-2 border">
                              <span
                                className={`px-2 py-1 text-white text-xs rounded ${badgeClass}`}
                              >
                                {row.percentage}%
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SystemRemarkModal;
